import React from 'react'
import image from './images/det.jpg'

const Header = () => {
    return (
        <div className="card bg-dark text-white">
            <img className="card-img" src={image}
                 alt="Card image"/>
        </div>
    )
}

export default Header;